import * as THREE from 'three';

export class Atmosphere{
    constructor(camera){
        this.camera = camera;
        this.changeIntensity = 0.0005;
        const geometry = new THREE.SphereGeometry( 0.57, 32, 32 );

        this.glowMaterial = new THREE.ShaderMaterial({
            uniforms:
                {
                    c:   { type: 'f', value: 0.9 },
                    p:   { type: 'f', value: 3.0 },
                    glowColor: { type: 'c', value: new THREE.Color(0x6fd6f9) },
                    viewVector: { type: 'v3', value: this.camera.position }
                },
            vertexShader: document.getElementById('vertexShaderSun').textContent,
            fragmentShader: document.getElementById('fragmentShaderSun').textContent,
            side: THREE.BackSide,
            blending: THREE.AdditiveBlending,
            transparent: true
        });

        this.mesh = new THREE.Mesh(geometry, this.glowMaterial);
    }

    move() {
        if( this.glowMaterial.uniforms.c.value >= 0.9 || this.glowMaterial.uniforms.c.value < 0.8) {
            this.changeIntensity *= -1;
        }

        this.glowMaterial.uniforms.c.value += this.changeIntensity;
        this.mesh.material.uniforms.viewVector.value =
            new THREE.Vector3().subVectors( this.camera.position, this.mesh.position );
    }

    getMesh() {
        return this.mesh;
    }
}
